@if (isLoading) {
  <div section class="ProductPage flex-column" style="align-items: center; height: 100%; padding: 50px;">
    @if (loadingLogo) {
      <img [src]="loadingLogo" style="max-width: 100%;" [draggable]="false" />
    }

    <span>loading...</span>
  </div>
} @else if (!productView) {
  <section class="ProductPage flex-column" style="align-items: center;">
    @if (tenant?.Branding?.LogoImageUrl) {
      <img [src]="tenant.Branding.LogoImageUrl" style="max-width: 100%;" [draggable]="false"/>
    }
    <span>somethings gone wrong...</span>
  </section>
} @else {
  <section class="ProductPage">
    <div class="product-page-header">
      <h1>{{ productView.name }}</h1>

      @if (productView.isInDeal) {
        <a class="close-button" (click)="close()">
          <mat-icon >highlight_off</mat-icon>
        </a>
      } @else {
        <a class="close-button" [href]="productView.href" (click)="close($event)">
        <mat-icon>highlight_off</mat-icon>
      </a>
      }
    </div> 

    <div class="product-page-content">
      @if (!tenant.SuppressProductImages && productView.imageSource) {
        <div class="product-image-wrapper" 
             role="button" 
             tabindex="0"
             (click)="openImageLightbox(productView.imageSource)"
             (keydown.enter)="openImageLightbox(productView.imageSource)"
             (keydown.space)="openImageLightbox(productView.imageSource)">
          <img [src]="productView.imageSource" 
               class="product-image" 
               [alt]="productView.name"
               [draggable]="false"/>
          <div class="zoom-overlay">
            <mat-icon>zoom_in</mat-icon>
          </div>
        </div>
      }

      <p class="customise-info-description">{{ productView.description }}</p>

      @if (nutritionSummary) {
        <p class="customise-info-nutrition">{{ nutritionSummary }}</p>
      }

      @if (!isVariantAvailable) {
        <span class="customise-options-price-amount" style="color: red; font-size: 20px">
          Sorry - This product is currently unavailable.
        </span>
      } @else if (!productView.isInDeal) {
        <h2 class="customise-options-price-amount">
          {{ optionPrice$ | async | currency:'GBP' }}
        </h2>
      }

      @if (productView.allergens) {
        <div class="allergens">
          <div class="flex-column contains" style="margin-bottom: 10px;">
            <span class="header">Allergens:</span> 
            <span>{{ productView.allergens.containsSummary }}</span>
          </div>

          @if (productView.allergens.showMayContainMessage) {
            <div class="flex-column may-contain" style="margin-bottom: 10px;">
              <span class="header">May Contain:</span>
              <span>{{ productView.allergens.mayContainSummary }}</span>
            </div>
          }
        </div>

        @if (productView.allergens.showMayContainMessage) {
          <span class="may-contain-summary">
            'May Contain' means that there might be cross-contamination of this allergen at one of our ingredient suppliers.
          </span>
        }
      }

        @for (group of optionGroups; track $index) {
          @if (group.options.length > 1) {
            <div class="product-page-content-card">
              <div class="product-page-content-subGroups-header">
                <h2>{{ group.name }}</h2>
                @if (group.description) {
                  <span>{{ group.description }}</span>
                }
              </div>
      
              <ul class="product-page-content-subGroups-ul">
                @for (option of group.options; track $index) {
                  <li class="product-page-content-subGroups-li"
                      [ngClass]="{
                        'selected-modifier-item': option.selected,
                        'button-action-disabled': !option.variant
                      }"
                      (click)="selectOption(option)">
                    <div class="flex-column no-wrap" style="flex: 1;">
                      <span style="font-weight: bold; font-size: 12px;">{{ option.name }}</span>
                      @if (option.description) {
                        <span>{{ option.description }}</span>
                      }
                      @if (option.nutritionSummary) {
                        <span>{{ option.nutritionSummary }}</span>
                      }
                    </div>
        
                    <div style="display: flex; align-items: center;">
                      @if (option.allergens) {
                        <mat-icon class="allergens-info-icon" (click)="showAllergenDetails(option.allergens, option.name, option.description, ModifierAllergensModal)">
                          info
                        </mat-icon>
                      }
    
                      <span>{{ option.price }}</span>
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
        }

      @for (group of modifierGroups; track $index) {
        <div class="product-page-content-card">
          <div class="product-page-content-subGroups-header">
            <h2>{{ group.name }}</h2>
          </div>

          @if (group.singleSelection && !group.hasSelection) {
            <span style="color: red; font-weight: 500;">Please select one of the following.</span>
          }

          <div class="customise-toppings-body" [ngClass]="{'forced-modifier': group.singleSelection}">
            <ul class="customise-toppings-list">
              @for (modifier of group.modifiers; track $index) {
                <li class="customise-toppings-list-Item"
                    [ngClass]="{
                      'customise-toppings-list-item-modal': productView.isInDeal,
                      'selected-modifier-item': modifier.quantity > 0,
                      'unavailable': !modifier.available
                    }"
                    (click)="selectForcedModifier(group, modifier)">
                  <span style="flex: 1">
                      {{ modifier.name }}
                      @if (group.singleSelection) {
                        <span>{{ modifier.description }}</span>
                      }
                  </span>

                  @if (modifier.allergens) {
                    <mat-icon class="allergens-info-icon" (click)="showAllergenDetails(modifier.allergens, modifier.name, modifier.description, ModifierAllergensModal)">
                      info
                    </mat-icon>
                  }

                  @if (modifier.available) {
                    @if (modifier.price) {
                      <span class="customise-toppings-list-Item-price">{{ modifier.price | currency:'GBP' }}</span>
                    }

                    @if (!group.singleSelection) {
                      <div class="customise-toppings-list-Item-wrapper">
                        <div class="select-AddOns-Quantity-minus" [ngClass]="{'disabled': modifier.quantity === 0}" (click)="removeModifier(modifier)">
                          <mat-icon>remove_circle</mat-icon>
                        </div>
    
                        <span class="select-AddOns-Quantity">{{ modifier.quantity }}</span>
    
                        <div class="select-AddOns-Quantity-plus"
                             [class.disabled]="maxModifiersReached || (modifier.maxEach && modifier.quantity === modifier.maxEach)"
                             (click)="addModifier(modifier)">
                          <mat-icon>add_circle</mat-icon>
                        </div>
                      </div>
                    }
                  } @else {
                    <div class="customise-toppings-list-Item-unavailable">
                      currently <br> unavailable
                    </div>
                  }
                </li>
              }
            </ul>
          </div>
        </div>
      }
    </div>

    <!-- footer -->
    <div class="product-page-footer disable-select">
      @if (!productView.isInDeal) {
        <div class="product-page-footer-quantity flex-row no-wrap flex-center">
          <div class="select-AddOns-Quantity-minus" (click)="decrementQuantity()">
            <mat-icon>remove_circle</mat-icon>
          </div>
          <span class="select-AddOns-Quantity" style="margin: 0 5px;">{{ quantity$ | async }}</span>
          <div class="select-AddOns-Quantity-plus" (click)="incrementQuantity()">
            <mat-icon>add_circle</mat-icon>
          </div>
        </div>
      }

      <button class="product-page-footer-button button-action-mat button-action-1"
              [ngClass]="{'button-action-disabled': shouldDisableAddToButton()}"
              [disabled]="shouldDisableAddToButton()"
              tabindex="-1"
              mat-button
              (click)="addProductToBasket()">
        <div style="display: flex;">
          <div style="display: flex; align-items: center; flex: 1;">
            <mat-icon style="margin-right: 3px">add_circle</mat-icon>
            <span>Add to cart</span>
          </div>

          @if (!productView.isInDeal) {
            <span>{{ productPrice$ | async | currency:'GBP' }}</span>
          }
        </div>
      </button>
    </div>
  </section>
}

<ng-template #ModifierAllergensModal>
  <div class="allergen-header">
    <h1>{{ selectedProductInfo.allergens.data ? 'Allergen Information' : 'Product Information' }}</h1>
  </div>

  <div class="allergen-content">
    <div class="allergen-content-product">
      <h3>{{ selectedProductInfo.name }}</h3>

      @if (selectedProductInfo.description) {
        <span>{{ selectedProductInfo.description }}</span>
      }
    </div>

    <div class="allergen-content-info">
      @if (selectedProductInfo.allergens.data) {
        @if (selectedProductInfo.allergens.data.contains) {
          <div class="allergen-content-info-group">
            <span>This product <strong>contains</strong> the following allergens:</span>
            <ng-container *ngTemplateOutlet="allergensTemplate; context: { allergens: selectedProductInfo.allergens.data.contains }"></ng-container>
          </div>
        }
  
        @if (selectedProductInfo.allergens.data.mayContain) {
          <div class="allergen-content-info-group">
            <span>This product <strong>may contain</strong> the following allergens:</span>
            <ng-container *ngTemplateOutlet="allergensTemplate; context: { allergens: selectedProductInfo.allergens.data.mayContain }"></ng-container>
          </div>
        }
  
        @if (tenant.CustomerAllergensStatement) {
          <div style="margin: 5px -5px 0" [innerHTML]="tenant.CustomerAllergensStatement | keepHtml"></div>
        }
      }

      <div class="allergen-content-footer" (click)="closeModalById('allergensInfoModal')">
        <button mat-button>close</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #allergensTemplate let-allergens="allergens">
  @if (allergens.length > 0) {
    <div class="allergen-content-items">
      @for (allergen of allergens; track $index) {
        <img [src]="allergen.imageSource" />
        <span>{{ allergen.name }}</span>
      } 
    </div>
  }
</ng-template>
